import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetMyLedgerQuery } from '../services/ledger/ledgerApi';
import Loading from '../components/Loading';

function MyLedgerPage() {
  const navigate = useNavigate();

  // Get userType from localStorage
  const getUserType = () => {
    try {
      const userData = localStorage.getItem('user_data');
      if (userData) {
        const parsedData = JSON.parse(userData);
        return parsedData.userType;
      }
    } catch (error) {
      console.error('Error parsing user_data from localStorage:', error);
    }
    return null;
  };

  const userType = getUserType();

  // Fetch my ledger data
  const { data: response, isLoading, error } = useGetMyLedgerQuery({ userType });

  // Handle different response structures
  const ledgerData = Array.isArray(response?.data)
    ? response.data
    : Array.isArray(response)
    ? response
    : [];
  const lena = Number(response?.lena || 0);
  const dena = Number(response?.dena || 0);

  // Parse balance string like "2.51 ( Dena )" or use netBalance
  let balance = 0;
  let balanceType = 'Lena';

  if (typeof response?.balance === 'string') {
    const balanceStr = response.balance;
    const match = balanceStr.match(/([\d.]+)\s*\(\s*(\w+)\s*\)/);
    if (match) {
      balance = Number(match[1]);
      balanceType = match[2];
    }
  } else {
    balance = Math.abs(Number(response?.netBalance || 0));
    balanceType = (response?.netBalance || 0) >= 0 ? 'Lena' : 'Dena';
  }

  return (
    <div className="">
      <div className="bg-white rounded shadow">
        {/* Header */}
        <div className="bg-[#2c3e3e] text-white px-5 py-3 flex items-center justify-between">
          <h2 className="text-xl font-normal">My Ledger</h2>
          <button 
            onClick={() => navigate(-1)}
            className="bg-blue-500 text-white px-6 py-2 hover:bg-blue-600"
          >
            Back
          </button>
        </div>

        {/* Summary Section */}
        <div className="p-5 bg-white">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-lg">
            <div>
              <span className="text-green-600 font-semibold">
                Lena : {lena.toFixed(2)}
              </span>
            </div>
            <div>
              <span className="text-red-600 font-semibold">
                Dena : -{dena.toFixed(2)}
              </span>
            </div>
            <div>
              <span className={`font-semibold ${balanceType === 'Lena' ? 'text-green-600' : 'text-red-600'}`}>
                Balance: {balance.toFixed(2)} ( {balanceType} )
              </span>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          {isLoading ? (
            <div className="p-8 flex justify-center">
              <Loading />
            </div>
          ) : error ? (
            <div className="p-4 text-red-500 text-center">
              {error.message || 'Failed to load data'}
            </div>
          ) : (
            <table className="ledger-table w-full border-collapse">
              <thead className="bg-[#2c3e3e] text-white">
                <tr>
                  <th className="p-3 text-left border border-gray-600">Date</th>
                  {/* <th className="p-3 text-left border border-gray-600">Collection Name</th> */}
                  <th className="p-3 text-left border border-gray-600">Debit</th>
                  <th className="p-3 text-left border border-gray-600">Credit</th>
                  <th className="p-3 text-left border border-gray-600">Balance</th>
                  <th className="p-3 text-left border border-gray-600">Payment Type</th>
                  <th className="p-3 text-left border border-gray-600">Remark</th>
                </tr>
              </thead>
              <tbody>
                {ledgerData?.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="p-4 text-center text-gray-400">
                      No Data
                    </td>
                  </tr>
                ) : (
                  ledgerData?.map((item, index) => (
                    <tr key={index} className={`bg-white hover:bg-gray-50 ${/liya/i.test(item.paymentType||'') ? 'ledger-liya' : /diya/i.test(item.paymentType||'') ? 'ledger-diya' : ''}`}>
                      <td className="p-3 border border-gray-300">{item.date}</td>
                      {/* <td className="p-3 border border-gray-300">{item.collectionName || ''}</td> */}
                      <td className="p-3 border border-gray-300">{item.debit || 0}</td>
                      <td className="p-3 border border-gray-300">{item.credit?.toFixed(2) || '0.00'}</td>
                      <td className="p-3 border border-gray-300">{item.balance}</td>
                      <td className="p-3 border border-gray-300">{item.paymentType}</td>
                      <td className="p-3 border border-gray-300">{item.remark}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          )}
        </div>

        {/* Pagination */}
        {/* {!isLoading && !error && ledgerData.length > 0 && (
          <div className="p-4 flex justify-end items-center gap-2">
            <button 
              onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
              disabled={currentPage === 1}
              className="p-2 border border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
            >
              &lt;
            </button>
            <button className="px-4 py-2 bg-blue-500 text-white border border-blue-500">
              {currentPage}
            </button>
            <button 
              onClick={() => setCurrentPage(prev => prev + 1)}
              className="p-2 border border-gray-300 hover:bg-gray-100"
            >
              &gt;
            </button>
          </div>
        )} */}
      </div>
    </div>
  );
}

export default MyLedgerPage;